// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e547fe3e","370":"e6e58c0a","453":"99be56bd"}[chunkId] + ".chunk.js";
};